import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import Markdown from 'markdown-to-jsx';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

import { useGetFAQs } from '@lumirental/lumi-web-shared/lib/tanStackQuery/faq.queries';

import Accordion from '@/components/Accordion';
import BreadCrumb from '@/components/BreadCrumb';
import PageNotFoundContainer from '@/containers/PageNotFoundContainer';

import styles from '@/containers/FaqContainer/FaqContainer.style';

const useStyles = makeStyles()(styles);

export default function FaqContainer() {
  const [expanded, setExpanded] = useState('');

  const { classes } = useStyles();
  const { t } = useTranslation();

  const { faqContent, isError } = useGetFAQs();

  if (isError) {
    return <PageNotFoundContainer />;
  }

  return (
    <Container maxWidth="lg">
      <div className={classes.mainWrapper}>
        <BreadCrumb currentPage={t('FAQ')} />
        <div className={classes.titleWrapper}>
          <Typography variant="h2" className={classes.title}>
            {t('frequently_asked_question')}
          </Typography>
        </div>
        <Card className={classes.cardWrapper}>
          {faqContent &&
            faqContent.map((faqItem) => {
              const question = _get(faqItem, 'question', '');
              const answer = _get(faqItem, 'answer', '');
              const id = `${question}_${answer}`;
              const isExpanded = question === expanded;
              const titleClass = `${classes.accordianTitle} ${
                isExpanded ? 'expanded' : ''
              }`;
              return (
                <React.Fragment key={id}>
                  <Accordion
                    value={question}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    header={
                      // eslint-disable-next-line react/jsx-wrap-multilines
                      <>
                        <div className={classes.accordianTitleWrapper}>
                          <span className={classes.expandIcon}>
                            {!isExpanded && <AddIcon />}
                            {isExpanded && <RemoveIcon />}
                          </span>
                          <Typography
                            variant="subtitle2"
                            className={titleClass}
                          >
                            {question}
                          </Typography>
                        </div>
                      </>
                    }
                  >
                    <div className={classes.accordianContentWrapper}>
                      <Typography className={classes.accordianContent}>
                        <Markdown>{answer}</Markdown>
                      </Typography>
                    </div>
                  </Accordion>
                  <Divider
                    classes={{
                      root: classes.divider,
                    }}
                  />
                </React.Fragment>
              );
            })}
        </Card>
      </div>
    </Container>
  );
}
